import { z } from 'zod';

import { createItemEnvelopeSchema } from '@/libs/api';

const MeResultSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    email: z.string(),
    role: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
  })
  .transform(raw => ({
    id: raw.id,
    name: raw.name,
    email: raw.email,
    role: raw.role,
    createdAt: raw.created_at,
    updatedAt: raw.updated_at,
  }));

const MeApiSchema = createItemEnvelopeSchema(MeResultSchema);

export type MeDTO = z.infer<typeof MeApiSchema>;

export function toMeDTO(raw: unknown): MeDTO {
  return MeApiSchema.parse(raw);
}
